module.exports = __webpack_public_path__ + "img/61ne.bcbcca3c.svg";